import { useContext, useEffect } from 'react';
import MentionsByTopicContainer from 'components/Dashboard/Analytics/MentionsByTopicContainer';
import useAnalyticsHashesFunctions from 'components/Dashboard/Analytics/useAnalyticsHashesFunctions';
import { store } from 'components/Store';
import OverallSentimentContainer from 'components/Dashboard/Analytics/OverallSentimentContainer';
import SentimentOverTimeContainer from 'components/Dashboard/Analytics/SentimentOverTimeContainer';
import InterestByRegionContainer from 'components/Dashboard/Analytics/InterestByRegionContainer';
import { VocalWidgetContainer } from 'components/Dashboard/Analytics/ui/AnalyticsDashboard/MostVocalWidget';
import { individualHashHelper } from './embedIndividualHashHelper';

const EmbedAnalyticsIndividual = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { analyticsState } = state;

  const { chart, topic, teamId, setCurrentChart, singleGraph, tweetsEnabled } = props;
  const { addAnalyticsFilterHashToUrl } = useAnalyticsHashesFunctions();
  useEffect(() => {
    addAnalyticsFilterHashToUrl({
      individualHashHelper,
      chart: chart,
      setHashes: true,
    });
  }, [analyticsState, chart]);

  return (
    <div className='dashboard-root-container'>
      {!singleGraph && (
        <div className='analytics-widget-spacing pt-2 analytics-embed-back-button z-extra-max'>
          <button
            className='text-light-blue general-button action-state-hover px-3 py-2 rounded-lg'
            style={{ marginLeft: '-1em' }}
            onClick={() => setCurrentChart(null)}
          >
            <span className='icon-short-arrow-left mr-2 paragraph-p5' /> Back
          </button>
        </div>
      )}
      <div className='flex-grow-1 analytics-widget-content-container'>
        {(chart === 'Mentions' || chart === 'Tweets') && (
          <MentionsByTopicContainer
            customTopic={topic}
            teamId={teamId}
            embedWidget={true}
            chartType={chart}
            tweetsEnabled={tweetsEnabled}
          />
        )}
        {chart === 'Sentiment snapshot' && (
          <OverallSentimentContainer customTopic={topic} teamId={teamId} embedWidget={true} />
        )}
        {chart === 'Sentiment changes' && (
          <SentimentOverTimeContainer customTopic={topic} teamId={teamId} embedWidget={true} />
        )}
        {chart === 'Interest by region' && (
          <InterestByRegionContainer customTopic={topic} teamId={teamId} embedWidget={true} />
        )}
        {chart === 'Most vocal policymakers' && (
          <VocalWidgetContainer topic={topic} teamId={teamId} embedWidget={true} />
        )}
      </div>
    </div>
  );
};

export default EmbedAnalyticsIndividual;
